module.exports = __webpack_public_path__ + "img/4.fcf533e7.jpg";